export const convertToPDFTronParams = (
  coords: [number, number, number, number],
  pageWidth: number,
  pageHeight: number,
  rotation: string
): { x: number; y: number; width: number; height: number } => {
  const [xTopLeft, yTopLeft, xBottomRight, yBottomRight] = coords

  // start from top-left
  let x = xTopLeft * pageWidth
  let y = yTopLeft * pageHeight

  let width = (xBottomRight - xTopLeft) * pageWidth
  let height = (yBottomRight - yTopLeft) * pageHeight

  let newWidth: number
  let newHeight: number

  switch (rotation) {
    case 'e_90':
      newWidth = (xBottomRight - xTopLeft) * pageHeight
      newHeight = (yBottomRight - yTopLeft) * pageWidth
      x = yTopLeft * pageWidth
      y = pageHeight - xTopLeft * pageHeight - newWidth
      width = newHeight
      height = newWidth
      break
    case 'e_180':
      x = pageWidth - x - width
      y = pageHeight - y - height
      break
    case 'e_270':
      newWidth = (xBottomRight - xTopLeft) * pageHeight
      newHeight = (yBottomRight - yTopLeft) * pageWidth
      x = pageWidth - yTopLeft * pageWidth - newHeight
      y = xTopLeft * pageHeight
      width = newHeight
      height = newWidth
      break
  }

  const widthIncrease = width * 0.1
  const heightIncrease = height * 0.1

  // Update width and height
  width += widthIncrease
  height += heightIncrease

  // Adjust x and y to keep the box centered, but ensure they are not negative
  x = Math.max(0, x - widthIncrease / 2)
  y = Math.max(0, y - heightIncrease / 2)

  return {
    x: x,
    y: y,
    width: width,
    height: height,
  }
}
